import cssjanus from 'cssjanus';
import { STYLIS_CONTEXTS } from 'styles/stylis-plugin';

// StylisPlugin definition puts content on 4th place while it's actually second.
function RTLPlugin(context: number, content: any): string {
  if (context === STYLIS_CONTEXTS.PREPARATION) {
    return cssjanus.transform(content);
  }
  return content;
}
export default RTLPlugin;
